export default {
  refresh() {
    this.doRefresh();
  },

  endpoint() {
    this.doRefresh();
  },
};
